export default __webpack_public_path__ + "static/media/videoconference.1a80be96.svg";